import { CompactPatientDataComponent } from '@/src/app/features/reports/components/compact-patient-data/compact-patient-data.component';
import { PatientLinkComponentModule } from '@/src/app/features/reports/components/patient-link/patient-link.component';
import { GeneralCommonsModule } from '@/src/app/shared/modules/general-commons/general-commons.module';

import { ReadonlyCommonsModule } from '@/src/app/shared/modules/readonly-commons/readonly-commons.module';
import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';

@NgModule({
  imports: [
    CommonModule,
    PatientLinkComponentModule,
    ReadonlyCommonsModule,
    TranslateModule,
    GeneralCommonsModule,
    CompactPatientDataComponent
  ],
  exports: [CompactPatientDataComponent]
})
export class CompactPatientDataModule {}
